import Box from "@mui/material/Box";
import MuiBreadcrumbs from "@mui/material/Breadcrumbs";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { Link as RouterLink } from "react-router-dom";
import { selectBreadcrumbs } from "src/store/reducers/navigation/navigationSlice";

export const Breadcrumbs = () => {
  const { t } = useTranslation();
  // A page adds its own crumb before its name has loaded (or when it fails to); skip it rather
  // than render a dangling separator.
  const items = useSelector(selectBreadcrumbs).filter((item) => item.label);

  if (items.length === 0) return null;

  return (
    <MuiBreadcrumbs
      aria-label={t("nav.breadcrumb", { defaultValue: "Breadcrumb" })}
      separator="/"
      sx={(theme) => ({
        // The design's 22px main gap less its -8px crumb margin; <main> here is block flow, so
        // the crumb carries the whole 14px itself.
        mb: 1.75,
        "& .MuiBreadcrumbs-separator": {
          color: theme.palette.tokens.textFaint,
        },
      })}
    >
      {items.map((item, index) => {
        const isLast = index === items.length - 1;
        if (!item.path) {
          return (
            <Box
              key={`${index}-${item.label}`}
              component="span"
              aria-current={isLast ? "page" : undefined}
              sx={(theme) => ({
                fontSize: 13,
                fontWeight: 600,
                color: theme.palette.tokens.textMuted,
              })}
            >
              {item.label}
            </Box>
          );
        }
        return (
          <Box
            key={`${index}-${item.label}`}
            component={RouterLink}
            to={item.path}
            sx={(theme) => ({
              fontSize: 13,
              fontWeight: 600,
              color: theme.palette.primaryInk,
              textDecoration: "none",
              "&:hover": { textDecoration: "underline" },
              "&:focus-visible": {
                outline: `2px solid ${theme.palette.focusRing}`,
                outlineOffset: 2,
              },
            })}
          >
            {item.label}
          </Box>
        );
      })}
    </MuiBreadcrumbs>
  );
};

export default Breadcrumbs;
